import axios from 'axios';
import { API } from '../../Backend';
import {
    ANALYTICS_SUMMARY_REQUEST,
    ANALYTICS_SUMMARY_SUCCESS,
    ANALYTICS_SUMMARY_FAIL,
    TOP_PRODUCTS_REQUEST,
    TOP_PRODUCTS_SUCCESS,
    TOP_PRODUCTS_FAIL,
    TOP_CUSTOMERS_REQUEST,
    TOP_CUSTOMERS_SUCCESS,
    TOP_CUSTOMERS_FAIL,
    SALES_DATA_REQUEST,
    SALES_DATA_SUCCESS,
    SALES_DATA_FAIL,
    SET_ANALYTICS_DATE_RANGE,
    SET_ANALYTICS_FINANCIAL_YEAR
} from '../constants/analyticsConstants';

const getConfig = () => ({
    headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    withCredentials: true
});

const buildRange = (fy, s, e) => `${fy}|${s}|${e}`;

// ── Set financial year (also resets dates via reducer) ──
export const setAnalyticsFinancialYear = (financialYear) => (dispatch) => {
    dispatch({ type: SET_ANALYTICS_FINANCIAL_YEAR, payload: financialYear });
};

// ── Set date range (persisted in Redux) ──
export const setAnalyticsDateRange = (startDate, endDate) => (dispatch) => {
    dispatch({ type: SET_ANALYTICS_DATE_RANGE, payload: { startDate, endDate } });
};

// ── Summary ──
export const getAnalyticsSummary = (startDate, endDate) => async (dispatch, getState) => {
    const { analytics } = getState();
    const fy = analytics.financialYear;
    const range = buildRange(fy, startDate, endDate);

    if (analytics.summaryRange === range && analytics.summary !== null) return;

    try {
        dispatch({ type: ANALYTICS_SUMMARY_REQUEST });
        const { data } = await axios.get(`${API}/analytics/summary`, {
            ...getConfig(),
            params: { startDate, endDate, financialTerm: fy }
        });
        dispatch({ type: ANALYTICS_SUMMARY_SUCCESS, payload: { data: data.summary, range } });
    } catch (error) {
        dispatch({ type: ANALYTICS_SUMMARY_FAIL, payload: error.response?.data?.message || error.message });
    }
};

// ── Top Products ──
export const getTopProducts = (startDate, endDate) => async (dispatch, getState) => {
    const { analytics } = getState();
    const fy = analytics.financialYear;
    const range = buildRange(fy, startDate, endDate);

    if (analytics.topProductsRange === range && analytics.topProducts.length > 0) return;

    try {
        dispatch({ type: TOP_PRODUCTS_REQUEST });
        const { data } = await axios.get(`${API}/analytics/top-products`, {
            ...getConfig(),
            params: { startDate, endDate, financialTerm: fy }
        });
        dispatch({ type: TOP_PRODUCTS_SUCCESS, payload: { data: data.topProducts, range } });
    } catch (error) {
        dispatch({ type: TOP_PRODUCTS_FAIL, payload: error.response?.data?.message || error.message });
    }
};

// ── Top Customers ──
export const getTopCustomers = (startDate, endDate) => async (dispatch, getState) => {
    const { analytics } = getState();
    const fy = analytics.financialYear;
    const range = buildRange(fy, startDate, endDate);

    if (analytics.topCustomersRange === range && analytics.topCustomers.length > 0) return;

    try {
        dispatch({ type: TOP_CUSTOMERS_REQUEST });
        const { data } = await axios.get(`${API}/analytics/top-customers`, {
            ...getConfig(),
            params: { startDate, endDate, financialTerm: fy }
        });
        dispatch({ type: TOP_CUSTOMERS_SUCCESS, payload: { data: data.topCustomers, range } });
    } catch (error) {
        dispatch({ type: TOP_CUSTOMERS_FAIL, payload: error.response?.data?.message || error.message });
    }
};

// ── Sales Data ──
export const getSalesData = (startDate, endDate) => async (dispatch, getState) => {
    const { analytics } = getState();
    const fy = analytics.financialYear;
    const range = buildRange(fy, startDate, endDate);

    if (analytics.salesDataRange === range && analytics.salesData.length > 0) return;

    try {
        dispatch({ type: SALES_DATA_REQUEST });
        const { data } = await axios.get(`${API}/analytics/sales`, {
            ...getConfig(),
            params: { startDate, endDate, financialTerm: fy }
        });
        dispatch({ type: SALES_DATA_SUCCESS, payload: { data: data.salesData, range } });
    } catch (error) {
        dispatch({ type: SALES_DATA_FAIL, payload: error.response?.data?.message || error.message });
    }
};
